import { ApiError, api } from '@/lib/api-client.ts';

import {
    type CreateDcCommunicationRequest,
    type CreatedDcCommunication,
    createDcCommunicationRequestSchema,
    createDcCommunicationResponseSchema,
} from '@/schemas/dc-communication.schema.ts';

import { ServiceUrl } from '@/services/ServiceURL.ts';

import { requireCustomerId } from '@/utils/customer-utils.ts';

/**
 * POST /secure-admin/doc-cirrus/communications/create — writes a COMMUNICATION activity into the patient's
 * case folder in Insuite.
 */
export const createDcCommunication = async (
    instanceId: string,
    body: CreateDcCommunicationRequest
): Promise<CreatedDcCommunication> => {
    if (!instanceId) {
        throw new ApiError(400, 'missing instance_id');
    }

    const parsedBody = createDcCommunicationRequestSchema.safeParse(body);
    if (!parsedBody.success) {
        throw new ApiError(400, 'Invalid communication request');
    }

    const response = await api.post(
        `${ServiceUrl.PATIENT_API_DOMAIN.SECURE_ADMIN.DOC_CIRRUS.COMMUNICATIONS}/create`,
        parsedBody.data,
        {
            headers: { customer_id: requireCustomerId() },
            params: { instance_id: instanceId },
        }
    );

    const parsed = createDcCommunicationResponseSchema.safeParse(response.data);
    if (!parsed.success) {
        throw new ApiError(502, 'Invalid doc-cirrus communication response');
    }

    return parsed.data.data;
};
